import plugin from "tailwindcss/plugin.js"
const fontFaces = [
  "xsmall-400",
  "xsmall-525",
  "xsmall-650",
  "small-400",
  "small-525",
  "small-650",
  "medium-400",
  "medium-525",
  "medium-650",
  "large-400",
  "large-525",
  "large-650",
  "xlarge-400",
  "xlarge-525",
  "xlarge-650",
  "2xlarge-400",
  "2xlarge-525",
  "2xlarge-650",
  "3xlarge-400",
  "3xlarge-525",
  "3xlarge-650",
  "4xlarge-400",
  "4xlarge-525",
  "4xlarge-650",
]
const STATIC_FONT_FACES = {
  ".font-inherit": {
    fontSize: "inherit",
    textDecoration: "inherit",
    fontFamily: "inherit",
    fontWeight: "inherit",
    fontStyle: "inherit",
    fontStretch: "inherit",
    letterSpacing: "inherit",
    textTransform: "inherit",
  },
}
export default plugin(({ addUtilities }) => {
  addUtilities(
    fontFaces.reduce((aggregate, fontFace) => {
      return {
        ...aggregate,
        [`.font-${fontFace}`]: {
          fontSize: `var(--typography-v2-${fontFace}-font-size)`,
          textDecoration: `var(--typography-v2-${fontFace}-text-decoration)`,
          fontFamily: `var(--typography-v2-${fontFace}-font-family)`,
          fontStyle: `var(--typography-v2-${fontFace}-font-style)`,
          fontStretch: `var(--typography-v2-${fontFace}-font-stretch)`,
          letterSpacing: `var(--typography-v2-${fontFace}-letter-spacing)`,
          // TODO: for now, setting all font-weights to 400. After design has had time to review and determine
          // where we should have higher weights, we will update this logic and update related classes | mattnicolay20250131
          fontWeight: 400,
        },
      }
    }, STATIC_FONT_FACES)
  )
})
